export default __webpack_public_path__ + "static/media/jeremy.737ddde1.jpg";